import constants from "../constants";

const { FETCH_USER_DONE } = constants;

export default function fetchUser() {
  return (dispatch) => {
    $.ajax({
      dataType: "jsonp",
      url: `${window.lp.auth.host}/users/status.json`,
    })
    .done((user) => {
      dispatch({
        type: FETCH_USER_DONE,
        data: user,
      });
    });
  };
}



// WEBPACK FOOTER //
// ./assets/shared/actions/fetchUser.js